import utils from './utils'

export default class NetworkObject {
  constructor(api) {
    this.api = api
  }

  getAll(endpoint, fields, includes, filters, onSuccess, onError) {
    let extras = ''
    if (includes) {
      extras += '&include=' + includes
    }
    if (fields) {
      extras += '&' + fields
    }
    if (filters) {
      extras += '&' + filters
    }
    return this.api.http_fibercloud
      .get('v1/' + endpoint + '?paginate=false' + extras, {
        headers: {
          companyuuid: utils.getCompanyUUID(),
        },
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  getAllInGivenWorkspace(
    endpoint,
    workspaceUUID,
    technicalType,
    onSuccess,
    onError,
  ) {
    let headers = {
      workspaceuuid: workspaceUUID,
      companyuuid: utils.getCompanyUUID(),
    }
    if (technicalType !== undefined) {
      headers.technicaltype = technicalType
    }
    return this.api.http_fibercloud
      .get('v1/' + endpoint + '?paginate=false', {
        headers,
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  getAllWithinPolygon(
    endpoint,
    technicalType,
    fieldFilters,
    fieldsToInclude,
    fieldsToAppend,
    usedByNetwork,
    polygon,
    projection,
    isNpv,
    onSuccess,
    onError,
  ) {
    let headers = utils.getHeaders()
    if(isNpv){
      delete headers.workspaceuuid
    }
    if (polygon) {
      headers.selectareatextgeom = polygon
      headers.selectareaprojection = projection
    }

    if (technicalType) {
      headers.technicaltype = technicalType
    }

    let extras = utils.getPreparedExtras(
      fieldFilters,
      fieldsToInclude,
      fieldsToAppend,
    )
    if (extras !== '') {
      extras = '&' + extras
    }

    return this.api.http_fibercloud
      .get(
        'v1/' +
          endpoint +
          '?paginate=false' +
          extras +
          '&usedbynetwork=' +
          usedByNetwork,
        {
          headers,
        },
      )
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  getByUUID(
    endpoint,
    uuid,
    fieldsToInclude,
    fieldsToAppend,
    workspaceUuidInclude,
    onSuccess,
    onError,
  ) {
    let headers = {
      companyuuid: localStorage.getItem('company_uuid') || '',
    }

    if (workspaceUuidInclude) {
      headers = utils.getHeaders()
    }

    let extras = utils.getPreparedExtras(null, fieldsToInclude, fieldsToAppend)
    if (extras !== '') {
      extras = '?' + extras
    }

    return this.api.http_fibercloud
      .get('v1/' + endpoint + '/' + uuid + extras, {
        headers,
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  createInBulk(endpoint, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post('v1/' + endpoint, data, {
        headers: utils.getHeaders(),
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  cloneInBulk(endpoint, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post('v1/' + endpoint + '/clone', data, {
        headers: utils.getHeaders(),
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  editInBulk(endpoint, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .put('v1/' + endpoint, data, {
        headers: utils.getHeaders(),
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  delete(endpoint, uuid, onSuccess, onError, action = null) {
    let includes = action ? action : ''
    return this.api.http_fibercloud
      .delete('v1/' + endpoint + '/' + uuid + includes)
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  deleteInBulk(endpoint, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete('v1/' + endpoint, { data: data })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  getTechnicalSitesWithTechnicalLocals(workspaceUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get('v1/technicalsites?include=technicallocals&paginate=false', {
        headers: {
          workspaceuuid: workspaceUuid,
          companyuuid: utils.getCompanyUUID(),
        },
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  getAllClosures(workspaceUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get('v1/closures?paginate=false', {
        headers: {
          workspaceuuid: workspaceUuid,
          companyuuid: utils.getCompanyUUID(),
        },
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  getClosuresByTechnicalLocal(closures,onSuccess, onError) {
    return this.api.http_fibercloud
      .get('v1/networks/draw/'+closures.technicalLocalUuid+"?object_type=technical_local"+"&workspace_uuid="+closures.workspaceid, {
        headers: {
          companyuuid: utils.getCompanyUUID(),
        },
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  getTechnicalLocalWithLogicalRelations(
    technicalLocalUUID,
    workspaceUUID,
    includes,
    onSuccess,
    onError,
  ) {
    let include = ''
    includes.forEach((item, index) => {
      include += item
      if (index < includes.length - 1) {
        include += ','
      }
    })
    return this.api.http_fibercloud
      .get(
        'v1/technicallocals/' +
          technicalLocalUUID +
          '?include=' +
          include +
          '&paginate=false',
        {
          headers: {
            workspaceuuid: workspaceUUID,
            companyuuid: utils.getCompanyUUID(),
          },
        },
      )
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  getInsidePolygon(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post('v1/networks/multiselect', data, {
        headers: utils.getHeaders(),
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  searchObjects(searchFor, word, data, signalAbort, onSuccess, onError) {
    return this.api.http_fibercloud
      .post('v1/networks/search?filter[' + searchFor + ']=' + word, data, {
        headers: utils.getHeaders(),
        cancelToken: signalAbort,
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  searchObjectsById(searchFor, word, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post('v1/networks/search?filter[' + searchFor + ']=' + word, data)
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  searchByAttributes(layer, filter, value, params, onSuccess, onError) {
    let extras = "";
    if (params.sort) {
      extras += "&sort=" + params.sort;
    }
    if (params.pageNumber) {
      extras += "&page[number]=" + params.pageNumber;
    }
    if (!params.paginate) {
      params.paginate = false;
    }
    return this.api.http_fibercloud
      .get('v1/networks/searchother?layer=' + layer +
        '&filter[' + filter + ']=' + value +
        '&paginate=' + params.paginate +
        extras
      )
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  searchNewPaginationPage({links, signalAbort}, onSuccess, onError) {
    return this.api.http_fibercloud
      .get(links, {
        headers: utils.getHeaders(),
        cancelToken: signalAbort,
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  searchAddress(data, token, onSuccess, onError) {
    return this.api.http_fibercloud
      .post('v1/consumable-apis', data, {
        cancelToken: token,
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  getLayerAttributes(layer, filter, onSuccess, onError) {
    let filters = ''
    if (filter) {
      filters = '&filter=' + filter
    }
    return this.api.http_fibercloud
      .get('v1/networks/layerattributes?layer=' + layer + filters)
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }
  getObjectInWorkspaceOrderByAttribute(layer, attribute, onSuccess, onError) {
    let filter = ''
    if (attribute) {
      filter = '&filter=' + attribute
    }
    return this.api.http_fibercloud
      .get('v1/networks/heatmap?layer=' + layer + filter, {
        headers: utils.getHeaders(),
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  getSlackNearestObjects(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post('v1/slacks/nearestobjects', data, {
        headers: utils.getHeaders(),
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  getConnectionsToJoinCables(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get('v1/cables/' + uuid + '/connections', {
        headers: utils.getHeaders(),
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  join(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .put('v1/cables/join', data)
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  reverseDirection({ uuid, force }, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/cables/" + uuid + "/reverse-direction", { force })
      .then(resp => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error)
      })
  }

  getCablesInClosure(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get('v1/closures/' + uuid + '/cables-in', {
        headers: utils.getHeaders(),
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  getCablesOutClosure(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get('v1/closures/' + uuid + '/cables-out', {
        headers: utils.getHeaders(),
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  getCablesPassingInTechPoint(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get('v1/technicalpoints/' + uuid + '/cables-passing', {
        headers: utils.getHeaders(),
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  getPathwaysPassingTechPoint(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get('v1/technicalpoints/' + uuid + '/pathways', {
        headers: utils.getHeaders(),
      })
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  /**
   * Sends the request to the backend to create the tech points
   *
   * @param {Object} data - the data containing the tech points and the pathway
   * @returns
   */
  createBulkTechPoints(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post('v1/technicalpoints/storeBulk', data)
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }

  getObstructionTypeFields(obstructionType, includes, onSuccess, onError) {
    let includesString = includes ? "&include="+includes : "";
    let obstructionTypeString = obstructionType ? "&obstruction_type="+obstructionType : "";
    return this.api.http_fibercloud
      .get('v1/blockagefields?paginate=false' + obstructionTypeString + includesString)
      .then((resp) => {
        onSuccess(resp)
      })
      .catch((error) => {
        onError(error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/network_object.js